import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE } from '../lib/config';

const API = `${API_BASE}`;

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const ReviewNew = () => {
  const q = useQuery();
  const navigate = useNavigate();
  const targetId = q.get('target_id') || '';
  const targetRole = q.get('target_role') || 'employer';
  const [rating, setRating] = useState(5);
  const [tags, setTags] = useState('');
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  const submit = async (e) => {
    e.preventDefault();
    if (!targetId) {
      alert('対象が指定されていません');
      return;
    }
    try {
      setSaving(true);
      const resp = await fetch(`${API}/reviews`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ target_id: targetId, target_role: targetRole, rating: Number(rating), tags: tags ? tags.split(',').map(s=>s.trim()).filter(Boolean) : [], comment })
      });
      if (!resp.ok) throw new Error('failed');
      alert('レビューを投稿しました');
      navigate(-1);
    } catch (e) {
      console.error(e);
      alert('投稿に失敗しました');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4">
      <h1 className="text-xl font-bold mb-4">レビューを投稿</h1>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm text-gray-600">対象ID</label>
          <input value={targetId} readOnly className="w-full border rounded px-3 py-2 bg-gray-50"/>
        </div>
        <div>
          <label className="block text-sm text-gray-600">対象ロール</label>
          <select value={targetRole} onChange={e=>{}} className="w-full border rounded px-3 py-2 bg-gray-50">
            <option value="employer">employer</option>
            <option value="job_seeker">job_seeker</option>
          </select>
        </div>
        <div>
          <label className="block text-sm text-gray-600">評価（1-5）</label>
          <input type="number" min="1" max="5" value={rating} onChange={e=>setRating(e.target.value)} className="w-full border rounded px-3 py-2"/>
        </div>
        <div>
          <label className="block text-sm text-gray-600">タグ（カンマ区切り）</label>
          <input value={tags} onChange={e=>setTags(e.target.value)} className="w-full border rounded px-3 py-2" placeholder="丁寧,時間厳守 など"/>
        </div>
        <div>
          <label className="block text-sm text-gray-600">コメント</label>
          <textarea value={comment} onChange={e=>setComment(e.target.value)} rows={4} className="w-full border rounded px-3 py-2"/>
        </div>
        <div className="flex gap-2">
          <button type="submit" disabled={saving} className={`px-4 py-2 rounded text-white ${saving?'bg-gray-400':'bg-blue-600 hover:bg-blue-700'}`}>投稿</button>
          <button type="button" onClick={()=>navigate(-1)} className="px-4 py-2 rounded border">戻る</button>
        </div>
      </form>
    </div>
  );
};

export default ReviewNew;
